import GroupsIcon from "@mui/icons-material/GroupsRounded";
import KeyIcon from "@mui/icons-material/KeyRounded";
import PeopleIcon from "@mui/icons-material/PeopleOutlineRounded";
import RequestQuoteIcon from "@mui/icons-material/RequestQuoteRounded";
import SubjectIcon from "@mui/icons-material/SubjectRounded";
import DocumentIcon from "@entrilia/shared/icons/DocumentIcon";
import type { DataImportTarget } from "../../../../../api/types/dataImportTypes";
import PortfolioMonitoringIcon from "../../../../common/domain-icons/PortfolioMonitoringIcon";
import TimeSeriesIcon from "@entrilia/shared/icons/TimeSeriesIcon";

interface Props {
  target: DataImportTarget;
}

const ImportCsvTargetIcon = ({ target }: Props) => {
  switch (target) {
    case "PlatformObjects":
      return <SubjectIcon />;
    case "PortfolioMonitoringMetrics":
      return <PortfolioMonitoringIcon />;
    case "PortfolioMonitoringMetricValues":
      return <TimeSeriesIcon />;
    case "DocumentCollections":
      return <DocumentIcon />;
    case "Contacts":
      return <PeopleIcon />;
    case "ContactAccess":
      return <KeyIcon />;
    case "Investors":
      return <GroupsIcon />;
    case "CommitmentDrafts":
      return <RequestQuoteIcon />;
    default:
      return null;
  }
};

export default ImportCsvTargetIcon;
